import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsFor() {
  const forItems = ['Padres que sienten que han perdido la comunicación total con su hijo.', 'Familias que ven a su adolescente encerrado, apático o irritable todo el día.', 'Padres hispanos en EE. UU. que buscan herramientas prácticas y culturalmente sensibles.', 'Cuidadores que necesitan saber qué hacer hoy mismo mientras esperan una cita con el psicólogo.'];
  const notForItems = ['Padres que buscan una "cura milagrosa" de una noche para la depresión clínica.', 'Personas que no están dispuestas a cambiar su propia forma de hablar y reaccionar.', 'Quienes buscan un reemplazo para el tratamiento médico profesional.'];
  return <section className="bg-section-alt py-16 md:py-24 px-4" data-id="element-112">
      <div className="max-w-5xl mx-auto" data-id="element-113">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-114">
          {/* WHO IS FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-cream p-8 md:p-10 rounded-2xl border-t-4 border-success shadow-sm" data-id="element-115">
            <h3 className="font-heading text-2xl text-navy font-bold mb-8 flex items-center" data-id="element-116">
              <CheckCircleIcon className="w-8 h-8 text-success mr-3" data-id="element-117" />
              Para quién es esto:
            </h3>
            <ul className="space-y-6" data-id="element-118">
              {forItems.map((item, index) => <li key={index} className="flex items-start" data-id="element-119">
                  <CheckCircleIcon className="w-6 h-6 text-success flex-shrink-0 mr-3 mt-1 opacity-80" data-id="element-120" />
                  <span className="font-body text-charcoal text-lg" data-id="element-121">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* WHO IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-warm p-8 md:p-10 rounded-2xl border-t-4 border-danger-soft shadow-sm" data-id="element-122">
            <h3 className="font-heading text-2xl text-navy font-bold mb-8 flex items-center" data-id="element-123">
              <XCircleIcon className="w-8 h-8 text-danger-soft mr-3" data-id="element-124" />
              Para quién NO es:
            </h3>
            <ul className="space-y-6" data-id="element-125">
              {notForItems.map((item, index) => <li key={index} className="flex items-start" data-id="element-126">
                  <XCircleIcon className="w-6 h-6 text-danger-soft flex-shrink-0 mr-3 mt-1 opacity-80" data-id="element-127" />
                  <span className="font-body text-charcoal text-lg" data-id="element-128">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}